import { gameLogDataSchema } from './GameLog.ts';
import { createNumericKeyRecordSchema } from './KeyRecordSchemas.ts';
import { validateState } from './ValidateState.ts';
export const gameLogStateSchema = createNumericKeyRecordSchema(gameLogDataSchema);
export function validateGameLogState(data) {
    return validateState(gameLogStateSchema, data);
}
export const gameLogStatePartialSchema = createNumericKeyRecordSchema(gameLogDataSchema, {
    requireAtLeastOneEntry: true
});
export function validateGameLogStatePartial(data) {
    return validateState(gameLogStatePartialSchema, data);
}
